<template>
	<div class="col-sm-12 col-lg-2">
		<div class="filter__wrapper" :class="{open: 'name' === showList, close: 'name' !== showList}">
			<input type="text"
				   :placeholder="$t('filters.judge')"
				   class="filter"
				   :class="{open: 'name' === showList, close: 'name' !== showList}"
				   @click="updateShowList('name')"
				   @input="showList = 'name'"
				   v-model="searchByName"
			>
			<ul v-show="'name' === showList"
				class="filter__list"
			>

				<li v-for="item in namesList"
					class="filter__list-item"
				>
					<label class="filter__label">{{item.full_name}}
						<input class="filter__input"
							   type="checkbox"
							   :value="item"
							   :checked="$store.getters.isJudgesNameActive(item)"
							   @change="changeFilters($event, item)"
						>
						<span class="filter__checkbox"></span>
					</label>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapMutations } from 'vuex'
	import sortJudgesByName from '@/assets/js/sortJudgesByName'

	export default {
		data () {
			return {
				showList: '',
				searchByName: ''
			}
		},
		methods: {
			...mapActions(['fetchEvents']),
			...mapMutations(['editFilters']),
			...mapActions(['fetchNames']),
			changeFilters (e, item) {
				if (e.target.checked) {
					this.$store.commit('addJudgeName', item)
					this.fetchEvents()
				} else {
					this.$store.commit('removeJudgeName', item)
					this.fetchEvents()
				}
			},
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFiltersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			}
		},
		computed: {
			namesList () {
				const inputTest = person => {
					const regExp = new RegExp('^' + this.searchByName, 'i')
					return regExp.test(person.full_name)
				}

				const filterNames = this.$store.state.events.name.filter(inputTest)

				return sortJudgesByName(filterNames)
			}
		},
		created () {
			window.addEventListener('click', this.closeFiltersLists)
			this.fetchNames()
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFiltersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";
</style>



// WEBPACK FOOTER //
// src/components/EventsList/Filters/NameFilterComponent.vue